import React from 'react'
import classnames from 'classnames'
import { Row, Col } from 'react-flexbox-grid'
import Card from '@material-ui/core/Card'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import Config from '../../../Config'

import HCSAExpenseLine from '../../../widgets/SubmitAClaim/HCSAExpenseLine'
import NoServerError from '../../../widgets/SubmitAClaim/NoServerError'
import { localize } from '../../../util/Localizer'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { push } from 'connected-react-router'

import {
  fetchUnclaimedHCSAExpenses,
  changePage,
  updatePeriodTotals,
  setFilters
} from '../../../redux/actions/submitExpenseActions'

import EmptyClaimsState from '../../../widgets/Claims/EmptyClaimsState'

import { formatCurrency } from '../../../util/CurrencyFormatter'
import Loading from '../../../widgets/Loading'
import NotificationSystem from 'react-notification-system'
import Divider from '@material-ui/core/Divider'
import Checkbox from '@material-ui/core/Checkbox'
import { withStyles } from '@material-ui/core/styles'

import FormControlLabel from '@material-ui/core/FormControlLabel'

import PaginationStyles from '../../../styles/components/pagination'
import NotificationSystemStyle from '../../../styles/components/react-notification-system'
import RBButton from '../../../controls/RBButton'
import moment from 'moment'

import {
  calculateTotalsForUseOrLostExpense,
  calcualteTotalsForCarryForwardExpense,
  calcualteTotalsForCarryForwardBalance
} from './functions'
import { passNavCallbacks, goNext } from '../../../redux/actions/submitNavigationActions'

class HCSAExpenses extends React.Component {
  constructor (props) {
    super(props)
    this.PayfromHCSA = this.PayfromHCSA.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.updateClaim = this.updateClaim.bind(this)
    this.next = this.next.bind(this)
    this.changeNext = this.changeNext.bind(this)
    this.changePrev = this.changePrev.bind(this)
    this.changePage = this.changePage.bind(this)
    this.checkRiskMethod = this.checkRiskMethod.bind(this)
    this.updateMva = this.updateMva.bind(this)
    this.hasSHCClaim = this.hasSHCClaim.bind(this)
    this.notificationSystem = React.createRef()

    // get the totals if there are any
    let total = 0
    let cobTotal = 0
    if (props.claimObj.HCSAExpenseLines) {
      const unpaid = (total, num) => Number(total) + Number(num.UnpaidAmount)
      const unpaidCob = (total, num) => Number(total) + Number(num.CoordinationOfBenefitsAmount)
      total = props.claimObj.HCSAExpenseLines.reduce(unpaid, 0)
      cobTotal = props.claimObj.HCSAExpenseLines.reduce(unpaidCob, 0)
    }
    this.state = {
      HCSAExpenseLines: [],
      paidByOtherTotal: 0,
      checkBox: false,
      disablePrevPeriod: false,
      disableCurrPeriod: false,
      total: total.toFixed(2),
      CoordinationOfBenefitsAmount: cobTotal.toFixed(2),
      hasShownPartiallyPaidMessage: false,
      MVARelated: null
    }
  }

  componentDidMount () {
    let obj = {
      name: 'All',
      type: 'All',
      start: null,
      end: null,
      pageNum: 1
    }
    if (this.props.claimObj && this.props.claimObj.HCSAExpenseLines) {
      this.setState({ HCSAExpenseLines: this.props.claimObj.HCSAExpenseLines })
    }
    this.props.changePage(obj.pageNum)
    this.props.fetchUnclaimedHCSAExpenses(obj)
    this.props.setNext(null)
    this.props.setPercent(60)
    this.props.adjustScrollBar()
  }

  componentDidUpdate (prevProps) {
    const props = this.props

    if (props.name !== 'clear' && (props.name !== prevProps.name || props.type !== prevProps.type || props.startDate !== prevProps.startDate || props.endDate !== prevProps.endDate || props.pageNum !== prevProps.pageNum)) {
      let obj = {
        name: props.name || 'All',
        type: props.type || 'All',
        start: props.startDate || null,
        end: props.endDate || null,
        pageNum: props.pageNum || 1
      }
      props.fetchUnclaimedHCSAExpenses(obj)
    }
  }

  addNotification (message) {
    const notification = this.notificationSystem.current
    if (notification === undefined) { return }

    // clear all notifications
    notification.clearNotifications()

    // show the notification if available
    if (message) {
      notification.addNotification({
        title: message,
        level: 'error',
        position: 'tc',
        autoDismiss: 5,
        uid: 1
      })
    }
  }

  updateMva (value) {
    const { claimObj = {} } = this.props
    const nextClaimObj = {
      ...claimObj,
      MVARelated: value
    }
    this.props.updateClaim(nextClaimObj)
    this.setState({ MVARelated: value }, () => this.next())
  }

  PayfromHCSA (e, expenseDetail, cob, shouldUpdateClaim = true) {
    let exp = {
      ClaimId: expenseDetail.claimId,
      ClaimLineId: expenseDetail.claimLineId,
      ClaimType: expenseDetail.claimTypeEnglishName,
      UnpaidAmount: expenseDetail.unpaidAmount,
      CoordinationOfBenefitsAmount: cob,
      benefitPeriodId: expenseDetail.benefitPeriodId,
      isValid: expenseDetail.isValid
    }
    const isPreviousYearClaim = (this.props.hcsaExpenseData.pastYearPeriod && this.props.hcsaExpenseData.pastYearPeriod.benefitPeriodId === exp.benefitPeriodId) || false
    if (e.target.type !== 'text') {
      const selectedExpenses = [...this.state.HCSAExpenseLines]
      const isExpenseSelected = this.state.HCSAExpenseLines.filter((ed) => ed.ClaimId === exp.ClaimId && ed.ClaimLineId === exp.ClaimLineId).length > 0
      if (isExpenseSelected) {
        const removeIndx = selectedExpenses.findIndex(e => e.ClaimId === exp.ClaimId && e.ClaimLineId === exp.ClaimLineId)
        selectedExpenses[removeIndx].CoordinationOfBenefitsAmount = 0
        selectedExpenses.splice(removeIndx, 1)
      } else {
        const prospectTotal = parseFloat(exp.UnpaidAmount) + parseFloat(this.state.total)
        if (prospectTotal > this.props.hcsaBalance) {
          // Show message that you're running out of hcsaBalance
          this.addNotification(localize('pages.SubmitAClaim.UnpaidExpenses.InsufficientBalance'))
        } else {
          exp.CoordinationOfBenefitsAmount = expenseDetail.CoordinationOfBenefitsAmount || 0
          selectedExpenses.push(exp)
        }
      }

      this.checkRiskMethod(selectedExpenses, exp, isPreviousYearClaim, false, () => {
        if (shouldUpdateClaim) {
          this.updateClaim(selectedExpenses, this.next)
        }
      })
    }
  }

  updateClaim (expenses, onUpdate) {
    const unpaid = (total, num) => Number(total) + Number(num.UnpaidAmount)
    const unpaidCob = (total, num) => Number(total) + Number(num.CoordinationOfBenefitsAmount)
    let total = expenses.reduce(unpaid, 0)
    let cobTotal = expenses.reduce(unpaidCob, 0)

    // Update local state
    this.setState({
      HCSAExpenseLines: expenses,
      total: total.toFixed(2),
      CoordinationOfBenefitsAmount: cobTotal.toFixed(2)
    }, () => {
      if (typeof onUpdate === 'function') {
        // HACK: The single-frame setTimeout call ensures that we don't callback until the claim has
        // actually been updated in redux and the component props have updated. We really should be
        // using redux *or* state to store the claim, not both.
        setTimeout(onUpdate)
      }
    })
  }

  handleInputChange (expenseDetail, shouldUpdateClaim = true) {
    let exp = {
      ClaimId: expenseDetail.claimId,
      ClaimLineId: expenseDetail.claimLineId,
      ClaimType: expenseDetail.claimTypeEnglishName,
      UnpaidAmount: expenseDetail.unpaidAmount,
      CoordinationOfBenefitsAmount: Number(expenseDetail.CoordinationOfBenefitsAmount),
      benefitPeriodId: expenseDetail.benefitPeriodId,
      isValid: expenseDetail.isValid
    }
    const isPreviousYearClaim = (this.props.hcsaExpenseData.pastYearPeriod && this.props.hcsaExpenseData.pastYearPeriod.benefitPeriodId === exp.benefitPeriodId) || false
    const selectedExpenses = [...this.state.HCSAExpenseLines]
    const currentExpenseIndx = selectedExpenses.findIndex((expense) => expense.ClaimId === expenseDetail.claimId && expense.ClaimLineId === expenseDetail.claimLineId)

    if (currentExpenseIndx === -1) {
      return
    }

    selectedExpenses[currentExpenseIndx].CoordinationOfBenefitsAmount = Number(expenseDetail.CoordinationOfBenefitsAmount)
    selectedExpenses[currentExpenseIndx].isValid = expenseDetail.isValid

    this.checkRiskMethod(selectedExpenses, exp, isPreviousYearClaim, expenseDetail.CoordinationOfBenefitsAmount, () => {
      if (shouldUpdateClaim) {
        this.updateClaim(selectedExpenses, this.next)
      }
    })
  }

  next () {
    let totalExpensesSelected = this.state.HCSAExpenseLines ? this.state.HCSAExpenseLines.length : 0
    const { MVARelated = null } = this.props.claimObj
    const hasSHC = this.hasSHCClaim()
    const mvaRequired = Config.showMvaQuestion && hasSHC
    const mvaChecked = (MVARelated === 'true' || MVARelated === 'false') && hasSHC
    if (totalExpensesSelected === 0) {
      totalExpensesSelected = this.props.claimObj.HCSAExpenseLines ? this.props.claimObj.HCSAExpenseLines.length : 0
    }
    if (this.state.checkBox === true && (totalExpensesSelected > 0)) {
      let error = this.state.HCSAExpenseLines.find((line) => {
        return !line.isValid
      })
      if (this.props.hasCOB) {
        if (!error && (mvaRequired ? mvaChecked : true)) {
          // means none of the items in the selected items are invalid
          this.props.setNext('certifcationAndAuthorization')
          this.props.passNavCallbacks({
            onNext: {
              callback: () => {
                this.props.updateClaim(this.state)
                this.props.goNext()
              },
              async: false
            }
          })
        } else {
          // means we found some items that are invalid
          this.props.setNext(null)
        }
      } else if (mvaRequired ? mvaChecked : true) {
        // check that mav is selected before moving forward
        this.props.setNext('certifcationAndAuthorization')
        this.props.passNavCallbacks({
          onNext: {
            callback: () => {
              this.props.updateClaim(this.state)
              this.props.goNext()
            },
            async: false
          }
        })
      }
    } else {
      this.props.setNext(null)
    }
  }

  changePage (number) {
    this.props.changePage(number)
  }
  changeNext () {
    this.props.changePage(this.props.pageNum + 1)
  }
  changePrev () {
    this.props.changePage(this.props.pageNum - 1)
  }

  renderPagination () {
    const { classes = {} } = this.props
    const self = this
    let total = this.props.hcsaExpenseData.totalPages
    let currentPage = this.props.pageNum
    const buildPages = (pageNum, totalPages) => {
      let pages = Array.from({ length: totalPages }, (v, i) => ++i)

      if (totalPages > 9) {
        pages = pages.filter(page => {
          if (page < 3) { // first two
            return true
          } else if (page > totalPages - 2) { // Last two
            return true
          } else if (page >= pageNum - 2 && page <= pageNum + 2) { // padding when in the middle
            return true
          } else { return false }
        })
      }

      if (pages.length === 9 && pages[7] !== totalPages - 2 && pages[6] !== pages[7] - 1) { // Add the last ...
        pages.splice(7, 0, -1)
      }

      if (pages.length > 4 && pages[2] !== 3) { // Add the first ...
        pages.splice(2, 0, -1)
      } else if (pages.length >= 5 && pages.length < 9) {
        pages = pages.filter((page) => {
          if (page < 3) { // first two
            return true
          } else if (page > totalPages - 2) { // Last two
            return true
          } else if (page >= pageNum - 2 && page <= pageNum + 2) { // padding when in the middle
            return true
          } else { return false }
        })

        if (totalPages > currentPage + 3 && totalPages > 5) {
          pages.splice(pages.length - 2, 0, -1)
        } else if (currentPage > 3 && totalPages > 5) {
          pages.splice(2, 0, -1)
        } else if (totalPages < 6) {
          return pages
        }
      }

      return pages
    }

    let pagination = buildPages(currentPage, total, [[1, 2, 3, -1, 24, 25]])
    return (
      <Col className={classes.pagination}>
        <RBButton label={localize('pages.ariaLabel.previous')} variant='outlined' disabled={currentPage === 1} onClick={this.changePrev} />

        <div className={classes.paginationButtons}>
          <ul>
            {pagination.map(function (number, index) {
              const key = number === -1 ? 'dot' + index : number
              var output = number === -1 || number === -5
                ? <li
                  key={key}
                  id={number}
                  className={classes.pageButton}
                >...</li>
                : <li
                  key={key}
                  id={number}
                  onClick={() => { self.changePage(number) }}
                  className={classnames(classes.pageButton, { active: number === currentPage })}
                >{number}</li>

              return output
            })
            }
          </ul>
        </div>
        <RBButton label={localize('pages.ariaLabel.next')} variant='outlined' disabled={this.props.pageNum === total} onClick={this.changeNext} />
      </Col>
    )
  }

  renderResponsivePagination () {
    const { classes = {} } = this.props

    if (window.innerWidth < 1200) {
      return (
        <Col className={classnames(classes.responsivePagination, 'hidden-lg')} >
          <RBButton label={localize('pages.ariaLabel.previous')} disabled={this.props.pageNum === 1} variant='outlined' onClick={this.changePrev} />
          <div >
            <p>{this.props.pageNum} of {this.props.hcsaExpenseData.totalPages}</p>
          </div>
          <RBButton label={localize('pages.ariaLabel.next')} disabled={this.props.pageNum === this.props.hcsaExpenseData.totalPages} variant='outlined' onClick={this.changeNext} />
        </Col>
      )
    }
  }

  checkRiskMethod (lines, expense, isPreviousYearClaim, isExpenseAdded, onStateUpdate) {
    // calculate when to show message based on benefit period total - expenseLines.unpaidAmount
    // when the total has been reached, show the message **please note your claim will be paid out partially...
    // disable all claim lines from the previous period (based on date)

    const data = this.props.hcsaExpenseData
    if (!data) {
      return
    }

    const riskMethod = data.hcsaRiskMethod

    if (riskMethod === 'USEORLOST') { // example user 10004
      // use it or lose it - expense funds are period specific

      const {
        prevTotal,
        prevPeriodTotal,
        prevCobTotal,
        currTotal,
        currCobTotal,
        currPeriodTotal,
        isValid
      } = calculateTotalsForUseOrLostExpense(data, lines)

      const CobValid = this.props.hasCOB ? (this.state.HCSAExpenseLines.length === isValid.length) : false
      this.props.updatePeriodTotals({ prevPeriodTotal, currPeriodTotal })

      const {
        disableCurrPeriod,
        disablePrevPeriod
      } = this.calculateDisabledClaimsForUseOrLost(prevTotal, currTotal, expense.benefitPeriodId, currCobTotal, prevCobTotal)

      if (data.currentYearPeriod && (disableCurrPeriod || disablePrevPeriod || (currTotal - currCobTotal) > data.currentYearPeriod.benefitPeriodFunds) && !CobValid) {
        this.addNotification(localize('pages.SubmitAClaim.UnpaidExpenses.paidPartially'))
      }
      // in the case a user only has prev period
      if (!data.currentYearPeriod && (disableCurrPeriod || disablePrevPeriod || (prevTotal - prevCobTotal) > data.pastYearPeriod.benefitPeriodFunds) && !CobValid) {
        this.addNotification(localize('pages.SubmitAClaim.UnpaidExpenses.paidPartially'))
      }
      this.setState({
        disablePrevPeriod,
        disableCurrPeriod
      }, onStateUpdate)
    } else if (riskMethod === 'CFEXP') { // example user test6
      // carry forward expense - I am allowed to pay for previous years expenses using my HCSA funds from this period

      const {
        balance,
        prevTotal,
        currTotal,
        currPeriodFunds,
        bothClaimsTotal,
        bothPeriodsTotalFund,
        prevCob,
        currCob,
        isValid
      } = calcualteTotalsForCarryForwardExpense(data, lines)

      const CobValid = this.props.hasCOB ? (this.state.HCSAExpenseLines.length === isValid.length) : false

      if (isPreviousYearClaim) {
        if (balance > 0) {
          if (bothClaimsTotal > bothPeriodsTotalFund && !CobValid) {
            this.addNotification(localize('pages.SubmitAClaim.UnpaidExpenses.paidPartially'))
          } else {
            this.addNotification(localize('pages.SubmitAClaim.UnpaidExpenses.paidFromCurrentPeriod'))
          }
        }
      } else {
        if (currTotal > currPeriodFunds && !CobValid) {
          this.addNotification(localize('pages.SubmitAClaim.UnpaidExpenses.paidPartially'))
        }
      }

      this.setState({
        disablePrevPeriod: (balance > 0 && (bothClaimsTotal - prevCob) > bothPeriodsTotalFund),
        disableCurrPeriod: (currTotal - currCob) > currPeriodFunds
      }, onStateUpdate)

      this.props.updatePeriodTotals({
        prevPeriodTotal: (prevTotal - prevCob).toFixed(2),
        currPeriodTotal: (currTotal - currCob).toFixed(2)
      })
    } else if (riskMethod === 'CFBLNCE') { // example user test5
      // carry forward balance -  I am allowed to pay for previous years expenses using my HCSA funds from this period.
      const {
        currPeriodFunds,
        currDisplayTotal,
        prevPeriodFunds,
        prevDisplayTotal,
        prevPeriodPaidPartially,
        prevPeriodConsumed,
        validTotalCount
      } = calcualteTotalsForCarryForwardBalance(data, lines)

      const CobValid = this.props.hasCOB ? (this.state.HCSAExpenseLines.length === validTotalCount) : false
      if (!CobValid) {
        if (isPreviousYearClaim && (prevPeriodPaidPartially || prevPeriodConsumed)) {
          this.addNotification(localize('pages.SubmitAClaim.UnpaidExpenses.paidPartially'))
          this.setState({ hasShownPartiallyPaidMessage: true })
        } else if (isPreviousYearClaim && !prevPeriodPaidPartially && !prevPeriodConsumed) {
          this.setState({ hasShownPartiallyPaidMessage: false })
        }
        // console.log(currDisplayTotal >= currPeriodFunds, prevDisplayTotal >= prevPeriodFunds)
        if (prevPeriodConsumed && ((currDisplayTotal >= currPeriodFunds)) && !this.state.hasShownPartiallyPaidMessage) {
          this.addNotification(localize('pages.SubmitAClaim.UnpaidExpenses.paidPartially'))
          this.setState({ hasShownPartiallyPaidMessage: true })
        } else if ((currDisplayTotal >= currPeriodFunds) && (prevDisplayTotal >= prevPeriodFunds) && this.state.hasShownPartiallyPaidMessage) {
          // force error when there is nothing to claim
          this.addNotification(localize('pages.SubmitAClaim.UnpaidExpenses.paidPartially'))
        }
        if (prevPeriodConsumed && ((prevDisplayTotal >= prevPeriodFunds) && !this.state.hasShownPartiallyPaidMessage)) {
          this.addNotification(localize('pages.SubmitAClaim.UnpaidExpenses.paidPartially'))
          this.setState({ hasShownPartiallyPaidMessage: true })
        } else if ((currDisplayTotal >= currPeriodFunds) && (prevDisplayTotal >= prevPeriodFunds) && this.state.hasShownPartiallyPaidMessage) {
          // force error when there is nothing to claim
          this.addNotification(localize('pages.SubmitAClaim.UnpaidExpenses.paidPartially'))
        }
      }

      this.setState({
        disablePrevPeriod: prevDisplayTotal >= prevPeriodFunds,
        disableCurrPeriod: currDisplayTotal >= currPeriodFunds
      }, onStateUpdate)

      this.props.updatePeriodTotals({
        prevPeriodTotal: prevDisplayTotal.toFixed(2),
        currPeriodTotal: currDisplayTotal.toFixed(2)
      })
    }
  }

  calculateDisabledClaimsForUseOrLost (prevTotal, currTotal, benefitPeriodId, currCobTotal, prevCobTotal) {
    const data = this.props.hcsaExpenseData
    const prevFunds = Number(data.pastYearPeriod && data.pastYearPeriod.benefitPeriodFunds) || 0
    const currFunds = Number(data.currentYearPeriod && data.currentYearPeriod.benefitPeriodFunds) || 0
    let disablePrevPeriod = false
    let disableCurrPeriod = false

    if (benefitPeriodId === (data.pastYearPeriod && data.pastYearPeriod.benefitPeriodId) && (prevTotal - prevCobTotal) > prevFunds) {
      disablePrevPeriod = true
    } else if (benefitPeriodId === (data.pastYearPeriod && data.pastYearPeriod.benefitPeriodId)) {
      disablePrevPeriod = false
    }

    if (benefitPeriodId === (data.currentYearPeriod && data.currentYearPeriod.benefitPeriodId) && ((currTotal - currCobTotal) > currFunds)) {
      disableCurrPeriod = true
    } else if (benefitPeriodId === (data.currentYearPeriod && data.currentYearPeriod.benefitPeriodId)) {
      disableCurrPeriod = false
    }

    return { disablePrevPeriod, disableCurrPeriod }
  }

  renderLoading () {
    return (
      <Row start='xs'>
        <Col xs={12}>
          <Loading message={localize('common.loadingContent')} />
        </Col>
      </Row>
    )
  }

  hasSHCClaim () {
    const { HCSAExpenseLines = [] } = this.state
    const hasSHC = HCSAExpenseLines.find(expense => expense.ClaimType === 'Supplementary Health Care')
    return hasSHC !== undefined
  }

  renderExpenses () {
    const { hasCOB, hcsaExpenseData, claimObj = {} } = this.props
    const totalLabelwithCOB = hasCOB ? { xs: 5 } : { xs: 8 }
    const totalValwithCOB = hasCOB ? { xs: 2 } : null
    const { disableCurrPeriod, disablePrevPeriod, HCSAExpenseLines } = this.state

    const prevPeriodId = hcsaExpenseData.pastYearPeriod && hcsaExpenseData.pastYearPeriod.benefitPeriodId
    const currPeriodId = hcsaExpenseData.currentYearPeriod && hcsaExpenseData.currentYearPeriod.benefitPeriodId
    const claimList = this.props.hcsaExpenseData.claimList
    const { dateFormat } = Config
    const hasSHC = this.hasSHCClaim()

    function isCurrPeriod (e) {
      return e.benefitPeriodId === currPeriodId
    }
    function isPrevPeriod (e) {
      return e.benefitPeriodId === prevPeriodId
    }

    function hasCurrBreak (e) {
      return e.break === 'curr'
    }
    function hasPrevBreak (e) {
      return e.break === 'prev'
    }
    if (prevPeriodId) {
      const prevBreakPoint = claimList.findIndex(isPrevPeriod)
      if ((prevBreakPoint !== -1) && (claimList.findIndex(hasPrevBreak) === -1)) {
        claimList.splice(prevBreakPoint, 0, { break: 'prev' })
      }
    }
    if (currPeriodId) {
      const currBreakPoint = claimList.findIndex(isCurrPeriod)
      if ((currBreakPoint !== -1) && (claimList.findIndex(hasCurrBreak) === -1)) {
        claimList.splice(currBreakPoint, 0, { break: 'curr' })
      }
    }

    if (this.props.hcsaExpenseData.claimList && this.props.hcsaExpenseData.claimList.length > 0) {
      return (
        <div>
          <NotificationSystem ref={this.notificationSystem} style={NotificationSystemStyle} />
          {
            Array.from(claimList).map((expense, key) => {
              let currentPeriodId = 0
              if (hcsaExpenseData.currentYearPeriod) {
                currentPeriodId = hcsaExpenseData.currentYearPeriod.benefitPeriodId
              }

              let foundClaim
              if (HCSAExpenseLines) {
                foundClaim = HCSAExpenseLines.find((ed) => ed.ClaimId === expense.claimId && ed.ClaimLineId === expense.claimLineId)
              }

              const disabled = (expense.benefitPeriodId === currentPeriodId) ? disableCurrPeriod : disablePrevPeriod
              return expense.break
                ? (
                  <h4 key={key} className='mainColor'>
                    {
                      (expense.break === 'prev')
                        ? localize('pages.SubmitAClaim.Expenses.previousPeriod')
                        : localize('pages.SubmitAClaim.Expenses.currentPeriod')
                    } ({(expense.break === 'prev')
                      ? `${moment(hcsaExpenseData.pastYearPeriod.benefitPeriodStart).format(dateFormat)} to ${moment(hcsaExpenseData.pastYearPeriod.benefitPeriodEnd).format(dateFormat)}`
                      : `${moment(hcsaExpenseData.currentYearPeriod.benefitPeriodStart).format(dateFormat)} to ${moment(hcsaExpenseData.currentYearPeriod.benefitPeriodEnd).format(dateFormat)}`})
                  </h4>
                )
                : (
                  <HCSAExpenseLine key={key}
                    onClick={this.PayfromHCSA}
                    expenseDetail={expense}
                    hasCOB={this.props.hasCOB}
                    cob={foundClaim}
                    onBlur={this.handleInputChange}
                    onInputChange={this.handleInputChange}
                    disabled={disabled}
                    isExpenseSelected={foundClaim !== undefined}
                  />
                )
            })
          }
          <Row>
            <Col {...totalLabelwithCOB}>
              <Row end='xs'>
                <Col xs={12}>
                  <span className='titledLabelLabel claimid'>{localize('pages.SubmitAClaim.Expenses.Total')}</span>
                </Col>
              </Row>
            </Col>
            <Col {...totalValwithCOB}>
              <span className='titledLabelLabel claimid'>{formatCurrency(this.state.total || 0)}</span>
            </Col>
            {this.props.hasCOB
              ? <Col xs>
                <Row>
                  <Col>
                    <span className='titledLabelLabel claimid'>{formatCurrency(this.state.CoordinationOfBenefitsAmount || 0)}</span>
                  </Col>
                </Row>
              </Col>
              : null
            }
          </Row>
          {this.props.hcsaExpenseData.totalPages > 1 ? this.renderPagination() : null}
          <br />
          {this.props.hcsaExpenseData.totalPages > 1 ? this.renderResponsivePagination() : null}
          <Row>
            <Col xs={12}>
              <Divider />
            </Col>
          </Row>
          {Config.showMvaQuestion && hasSHC && <Row>
            <Col xs={12}>
              <p>{localize('pages.SubmitAClaim.Expenses.mvaRelatedLabel')}</p>
              <RadioGroup
                aria-label={localize('pages.SubmitAClaim.Expenses.mvaRelatedLabel')}
                value={claimObj.MVARelated}
                onChange={(e, v) => this.updateMva(v)}
              >
                <FormControlLabel
                  value={'true'}
                  control={<Radio color={'primary'} />}
                  label={localize('pages.SubmitAClaim.Expenses.mvaRelatedYes')}
                />
                <FormControlLabel
                  value={'false'}
                  control={<Radio color={'primary'} />}
                  label={localize('pages.SubmitAClaim.Expenses.mvaRelatedNo')}
                />
                <p className='mvaNoText'>{localize('pages.SubmitAClaim.Expenses.mvaRelatedNoText')}</p>
              </RadioGroup>
            </Col>
          </Row>}
          <Row>
            <Col xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.checkBox}
                    onChange={(e, v) => this.setState({ checkBox: v }, this.next)}
                    value={'true'}
                    color='primary'
                  />
                }
                label={`${localize('pages.SubmitAClaim.UnpaidExpenses.AcceptResponsibilityForAccuracyDataText1')} ${localize('pages.SubmitAClaim.UnpaidExpenses.AcceptResponsibilityForAccuracyDataText2')}`}
              />
            </Col>
          </Row>
        </div>)
    } else {
      return null
    }
  }

  renderZeroBalanceUI () {
    // sends a clear signal to the hcsa filter component(located in the base submit a claim component)
    // visibly clears filters
    const { name, type, startDate, endDate } = this.props
    if (this.props.memberSummary && Number(this.props.memberSummary.healthCareSpendingAccountBalance) === 0) {
      return (
        <div>
          <p style={{ border: '1px soilid red' }}>
            <span className='mainColor'>{localize('pages.SubmitAClaim.UnpaidExpenses.ZeroBalance')}</span>
          </p>
        </div>
      )
    } else if (this.props.hcsaExpenseData.claimList.length === 0) {
      if ((name !== 'All') || (type !== 'All') || (startDate !== null) || (endDate !== null)) {
        return (
          <div>
            <EmptyClaimsState
              filteredEmptyState
              clearFilters={() => this.props.setFilters({ name: 'clear' })}
            />
          </div>
        )
      } else {
        return (
          <div>
            <p><span className='mainColor'>{localize('pages.submitAClaim.Expense.NoPendingClaims')}</span></p>
          </div>
        )
      }
    } else return null
  }

  renderBody () {
    if (this.props.hcsaExpenseData) {
      return (
        <Row>
          <Col xs={12}>
            {this.renderExpenses()}
            {this.renderZeroBalanceUI()}
          </Col>
        </Row>
      )
    }
  }

  render () {
    let obj = {
      name: 'All',
      type: 'All',
      start: null,
      end: null,
      pageNum: this.props.pageNum
    }
    return (
      <div>
        <Card className='submitCard' style={{ paddingTop: 20 }}>
          <Row start='xs'>
            <Col xs={12}>
              {this.props.isLoading
                ? this.renderLoading()
                : this.props.expenseError
                  ? <NoServerError error={this.props.expenseError} retry={() => this.props.fetchUnclaimedHCSAExpenses(obj)} />
                  : this.renderBody()
              }
            </Col>
          </Row>
        </Card>
      </div>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return {
    hcsaExpenseData: state.SubmitExpenseReducer.hcsaExpenseData,
    expenseError: state.SubmitExpenseReducer.expenseError,
    isLoading: state.SubmitExpenseReducer.isLoading,
    claimObj: state.SubmitAClaimReducer.claimObj,
    hasCOB: state.SubmitAClaimReducer.claimObj && state.SubmitAClaimReducer.claimObj.cob,
    memberSummary: state.memberSummaryReducer.memberSummary,
    selectedExpenses: state.SubmitExpenseReducer.selectedExpenses || [],
    name: state.SubmitExpenseReducer.name || 'All',
    type: state.SubmitExpenseReducer.type || 'All',
    startDate: state.SubmitExpenseReducer.startDate || null,
    endDate: state.SubmitExpenseReducer.endDate || null,
    pageNum: state.SubmitExpenseReducer.pageNum || 1,
    prevPeriodTotal: state.SubmitExpenseReducer.prevPeriodTotal || 0.00,
    currPeriodTotal: state.SubmitExpenseReducer.currPeriodTotal || 0.00
  }
}

const ConnectedHCSAExpenses = connect(mapStateToProps, {
  push,
  fetchUnclaimedHCSAExpenses,
  changePage,
  updatePeriodTotals,
  setFilters,
  passNavCallbacks,
  goNext
})(injectIntl(HCSAExpenses))

const styles = {
  ...PaginationStyles
}

export default withStyles(styles)(ConnectedHCSAExpenses)



// WEBPACK FOOTER //
// ./src/components/SubmitAClaim/HCSAExpenses/index.js